export default (theme) => ({
  paper: {
    [theme.breakpoints.up('md')]: {
      borderRadius: 12,
      boxShadow: '0px 0px 20px rgba(0, 0, 0, 0.25)',
    },
  },
  divider: {
    backgroundColor: theme.palette.divider,
  },
  dialogContent: {
    height: 500,
    padding: 0,
  },
  subtitleWrapper: {
    display: 'flex',
    textAlign: 'center',
    padding: theme.spacing(2, 0),
  },
  dividerBottom: {
    backgroundColor: theme.palette.secondary.main,
    height: 2,
  },
  buttonForm: {
    justifyContent: 'space-between',
  },
})
